<script lang="ts" setup>
import { Heading } from '~ds/components/ui/typography';
import invertedIcecream from '~kui/public/images/kui/inverted-icecream.webp';
import padlock from '~kui/public/images/kui/padlock.webp';

interface Props {
  title: string;
  description: string;
  width?: 'md' | 'full';
  image?: 'error' | 'unauthorised';
}

const props = withDefaults(defineProps<Props>(), {
  width: 'md',
  image: 'error',
});

const imageToRender = computed(() => {
  if (props.image === 'error') {
    return invertedIcecream;
  }

  return padlock;
});

const widthVariantClasses = computed(() => {
  return twMerge(
    cva('', {
      variants: {
        width: {
          md: 'max-w-md',
          full: 'w-full',
        },
      },
    })({
      width: props.width,
    }),
  );
});
</script>

<template>
  <div
    class="flex flex-col items-center justify-center gap-4 text-center"
    :class="widthVariantClasses"
  >
    <img
      :src="imageToRender"
      class="w-32 aspect-[32/38] object-contain"
      alt=""
      role="presentation"
    >
    <Heading size="2xl" as="h1">
      {{ title }}
    </Heading>
    <p>{{ description }}</p>
  </div>
</template>
